import React from 'react';
import { Button, ButtonProps, CircularProgress } from '@mui/material';
import GetAppIcon from '@mui/icons-material/GetApp';

interface ExportButtonProps extends Omit<ButtonProps, 'startIcon'> {
  label: string;
  isLoading?: boolean;
}

export const ExportButton = ({ label, isLoading = false, disabled, ...buttonProps }: ExportButtonProps) => {
  return (
    <Button
      {...buttonProps}
      disabled={disabled || isLoading}
      startIcon={isLoading ? <CircularProgress size={14} color="inherit" /> : <GetAppIcon />}
    >
      {label}
    </Button>
  );
};
